"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTaskStateType = void 0;
const workflow_1 = require("@sierralabs/workflow");
const useStateNodeByStatus_1 = require("../../hooks/useStateNodeByStatus");
const useTaskWorkflow_1 = require("./useTaskWorkflow");
function useTaskStateType(task, status) {
    const workflow = (0, useTaskWorkflow_1.useTaskWorkflow)(task);
    const stateNode = (0, useStateNodeByStatus_1.useStateNodeByStatus)((task === null || task === void 0 ? void 0 : task.status) || status, workflow);
    const isFinal = (stateNode === null || stateNode === void 0 ? void 0 : stateNode.type) === workflow_1.StateNodeType.Final;
    return { isFinal };
}
exports.useTaskStateType = useTaskStateType;
//# sourceMappingURL=useTaskStateType.js.map